// theme.js
export const theme = {
  primaryDark: "var(--black)",
  primaryLight: "var(--white)",
  primaryPop: "var(--primaryPop)",
  primaryHover: "var(--primaryHover)",
  backDrop: "var(--softAccent)",
  mobile: "576px",
};
